// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';
import { PowerUp, PowerUpItemType } from 'app/src/components/PowerUp';
import { atlassianPowerUps } from 'app/scripts/data/directory';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { BaseDirectoryView } from './BaseDirectoryView';
import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';
const c = recupWithHelpers('directory_data_consent');
import notCompliantIcon from 'resources/images/directory/icons/notCompliant.svg';
import compliantIcon from 'resources/images/directory/icons/compliant.svg';
import { DirectoryLegacyPowerUps as directoryLegacyPowerUps } from './DirectoryLegacyPowerUps';
import { pluginIOCache } from 'app/scripts/views/internal/plugins/PluginIoCache';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { sendPluginTrackEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
const t = recupWithHelpers('directory_power_up_item');
import { Analytics } from '@trello/atlassian-analytics';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import xtend from 'xtend';

// eslint-disable-next-line @trello/enforce-variable-case
const PermissionsList = c.renderable(({ pluginName }) =>
  c.div(function () {
    c.p(() => c.format('by-you-clicking-add', { pluginName }));
    return c.ul(function () {
      c.li(() => c.format('access-this-board'));
      c.li(() =>
        c.format('add-content-to-this-board-such-as-attachments-to-cards'),
      );
      c.li(() =>
        c.format(
          'take-actions-on-this-board-such-as-moving-sorting-filtering-cards-or-lists',
        ),
      );
      return c.li(() =>
        c.format(
          'access-user-information-such-as-username-avatar-initials-and-full-name-for-users-on-this-board',
        ),
      );
    });
  }),
);

// eslint-disable-next-line @trello/enforce-variable-case
const PrivacyPolicy = c.renderable(function ({ pluginName, privacyPolicyUrl }) {
  if (privacyPolicyUrl) {
    return c.format(
      'for-more-information-please-see-power-ups-privacy-policy',
      {
        pluginName,
        privacyPolicyUrl,
      },
    );
  }

  return c.format(
    'for-more-information-please-see-power-ups-privacy-practices',
    { pluginName },
  );
});

// eslint-disable-next-line @trello/enforce-variable-case
const AtlassianDataConsent = c.renderable(({ pluginName, privacyPolicyUrl }) =>
  c.div('.directory-data-consent', function () {
    c.p(() =>
      c.format(
        'power-up-is-developed-and-maintained-by-another-company-within-the-atlassian-corporate-family',
        { pluginName },
      ),
    );
    c.tag(PermissionsList, { pluginName });
    return c.tag(PrivacyPolicy, { pluginName, privacyPolicyUrl });
  }),
);

// eslint-disable-next-line @trello/enforce-variable-case
const PersonalDataCompliance = c.renderable(({ pluginName, isCompliant }) => {
  return c.div('.directory-compliance', () =>
    c.p(function () {
      const src = isCompliant === false ? notCompliantIcon : compliantIcon;

      c.img('.directory-compliance-icon', {
        src,
        alt: '',
        role: 'presentation',
      });
      if (isCompliant === false) {
        return c.format(
          'power-up-does-not-comply-with-our-data-privacy-standards',
          { pluginName },
        );
      } else if (isCompliant === true) {
        return c.format(
          'power-up-stores-data-complies-with-our-data-privacy-standards',
          { pluginName },
        );
      } else {
        return c.format('power-up-complies-with-our-data-privacy-standards', {
          pluginName,
        });
      }
    }),
  );
});

// eslint-disable-next-line @trello/enforce-variable-case
const ThirdPartyDataConsent = c.renderable(
  ({ pluginName, privacyPolicyUrl, isPublic, isCompliant }) =>
    c.div('.directory-data-consent', function () {
      c.p(() =>
        c.format('power-up-is-not-developed-or-maintained-by-trello', {
          pluginName,
        }),
      );

      if (isPublic) {
        c.tag(PersonalDataCompliance, { pluginName, isCompliant });
      }
      c.tag(PermissionsList, { pluginName });
      return c.tag(PrivacyPolicy, { pluginName, privacyPolicyUrl });
    }),
);

class DirectoryPluginEnableView extends BaseDirectoryView {
  static initClass() {
    this.prototype.className = 'directory-listing-wrapper';

    this.prototype.renderContent = t.renderable(function () {
      const pluginName = this.io.getName();
      const iconUrl = this.io.getIconUrl();
      const author = this.plugin.get('author');
      const privacyPolicyUrl = this.plugin.get('privacyUrl');
      const isAtlassianOwned = Array.from(atlassianPowerUps).includes(
        this.plugin.id,
      );
      const isPublic = this.plugin.get('public');
      const isCompliant = this.plugin.get('isCompliantWithPrivacyStandards');

      return t.div('.directory-individual-listing', () => {
        t.div(() => {
          return t.tag(PowerUp, {
            type: PowerUpItemType.Listing,
            atomProps: {
              subtitle: author,
              icon: {
                url: iconUrl,
              },
              name: pluginName,
            },
          });
        });
        if (isAtlassianOwned) {
          t.tag(AtlassianDataConsent, {
            pluginName,
            privacyPolicyUrl,
          });
        } else {
          t.tag(ThirdPartyDataConsent, {
            pluginName,
            privacyPolicyUrl,
            isPublic,
            isCompliant,
          });
        }
        return t.div('.directory-enable-page-buttons', () => {
          t.button('.button.link', { onClick: this.cancel.bind(this) }, () =>
            t.formatText('cancel'),
          );
          return t.button(
            '.nch-button.nch-button--primary.mt-4.mr-4',
            { onClick: this.enable.bind(this) },
            () => t.formatText('add'),
          );
        });
      });
    });
  }

  eventSource() {
    return 'powerUpAddDetailsScreen';
  }

  initialize({ directoryView, plugin, currentPage }) {
    this.directoryView = directoryView;
    this.plugin = plugin;
    this.tags = this.plugin.get('tags');
    this.currentPage = currentPage;
    super.initialize(...arguments);
    this.io = pluginIOCache.get(this.plugin);
    this.isEnabling = false;

    this.pluginDetails = {
      isLegacy: Array.from(_.pluck(directoryLegacyPowerUps, 'id')).includes(
        this.plugin.id,
      ),
    };

    if (this.pluginDetails.isLegacy) {
      const legacyPlugin = _.findWhere(directoryLegacyPowerUps, {
        id: this.plugin.id,
      });
      return (this.pluginDetails = xtend(this.pluginDetails, legacyPlugin));
    }
  }

  isGrandfathered() {
    return (
      this.pluginDetails.isLegacy &&
      Array.from(this.model.get('powerUps')).includes(this.pluginDetails.name)
    );
  }

  enable(e) {
    if (this.isEnabling) {
      return;
    }
    this.isEnabling = true;
    stopPropagationAndPreventDefault(e);
    const pluginAttributes = {
      pluginId: this.plugin.id,
      pluginName: this.plugin.name,
      pluginTags: this.tags,
      installSource: 'boardDirectory',
    };
    const traceId = Analytics.startTask({
      taskName: 'enable-plugin',
      source: 'addPowerUpButton',
    });

    const elem = e.target;

    this.model.enablePluginWithTracing(this.plugin.id, {
      traceId,
      attributes: pluginAttributes,
      taskName: 'enable-plugin',
      source: 'addPowerUpButton',
      next: (err) => {
        if (err) {
          const errorMessage = err.serverMessage;
          Analytics.taskFailed({
            taskName: 'enable-plugin',
            source: 'addPowerUpButton',
            error: new Error(errorMessage),
            attributes: {
              ...pluginAttributes,
            },
            traceId,
          });

          if (this.isGrandfathered()) {
            this.model.pull('powerUps', this.pluginDetails.name);
          } else {
            const disableTraceId = Analytics.startTask({
              taskName: 'disable-plugin',
              source: 'addPowerUpButton',
              attributes: pluginAttributes,
            });
            this.model.disablePluginWithTracing(this.plugin.id, {
              traceId: disableTraceId,
              attributes: pluginAttributes,
              taskName: 'disable-plugin',
              source: 'addPowerUpButton',
            });
          }
          if (errorMessage === 'PLUGIN_NOT_ALLOWED') {
            Alerts.show('plugin not allowed', 'error', 'addpluginerror', 4000);
          } else {
            Alerts.show(
              'could not add plugin',
              'error',
              'addpluginerror',
              2000,
            );
          }
        }
      },
    });

    if (this.io.supports('on-enable')) {
      return pluginRunner
        .one({
          plugin: this.plugin,
          command: 'on-enable',
          board: this.model,
          el: elem,
        })
        .catch((err) => {
          console?.warn('Failed to handle on-enable command.', {
            error: err.message,
            id: this.plugin.id,
          });
        })
        .finally(() => {
          return this.pluginEnabled(traceId);
        });
    } else {
      return this.pluginEnabled(traceId);
    }
  }

  pluginEnabled(traceId) {
    sendPluginTrackEvent({
      idPlugin: this.plugin.id,
      idBoard: this.model.id,
      event: {
        action: 'added',
        actionSubject: 'powerUp',
        attributes: {
          installSource: 'boardDirectory',
          tags: this.tags,
          taskId: traceId,
        },
        source: 'addPowerUpButton',
      },
    });

    this.isEnabling = false;
    return this.directoryView.navigate({ idPlugin: this.plugin.id });
  }

  cancel() {
    return this.directoryView.navigateBack();
  }
  render() {
    super.render(...arguments);

    this.directoryView.trackScreenEvent(this.eventSource(), {
      powerUpId: this.plugin.id,
      tags: this.tags,
    });

    return this;
  }
}

DirectoryPluginEnableView.initClass();
export { DirectoryPluginEnableView };
